module.exports = __webpack_public_path__ + "media/trucks/small_truck-3bc40141.svg";